/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2023 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * TooltipWrappper component
 *
 * @file TooltipWrappper.jsx
 * @author Gladson Samuel S
 * @since 1.0.32
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';

const TooltipWrapper = ({ children, showTooltip, ...rest }) => (
  <Fragment>
    {showTooltip
      ? (
        <Tooltip
          {...rest}
        >
          { children }
        </Tooltip>
      )
      : (
        <Fragment>
          { children }
        </Fragment>
      )
    }
  </Fragment>
);

TooltipWrapper.defaultProps = {
  showTooltip: true
};

TooltipWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  showTooltip: PropTypes.bool
};

export default TooltipWrapper;
